import React from "react";
import map from "lodash/map";

function View(props, { locals }) {
  const referAsClients = locals?.activeUser?.referAsClients || false;
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Strength Book"
      />

      <form method="POST" data-noreset>
        {locals.query.referral && (
          <input
            type="hidden"
            name="referralCode"
            defaultValue={locals.query.referral}
          />
        )}

        <div className="Steps" data-step="1">
          <div className="step" />
          <div className="step" />
          <div className="step" />
          <div className="step" />
        </div>

        <div className="frame">
          <div className="head">
            <h1 className="alt">
              {referAsClients ? "Client" : "Athlete"} Sign Up
            </h1>
            <p>Start analyzing your training by filling out the form below!</p>
          </div>

          {locals.query.coach && (
            <input
              type="hidden"
              name="coach"
              defaultValue={locals.query.coach}
            />
          )}
          <div className="columns">
            <div className="column" data-col="1/2">
              <label htmlFor="first_name" className="label">
                First name <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="text"
                name="first_name"
                placeholder="First name"
              />
            </div>
            <div className="column" data-col="1/2">
              <label htmlFor="last_name" className="label">
                Last name <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="text"
                name="last_name"
                placeholder="Last name"
              />
            </div>

            <div className="column hide-field-signup" data-col="1/1">
              <label htmlFor="country" className="label">
                Country <span className="required-input">*</span>
              </label>
              <select
                className="select-input"
                name="country"
                defaultValue="US"
                value="US"
                required
              >
                <option hidden value="">
                  Choose your location...
                </option>
                {map(locals.countries, (code) => {
                  return (
                    <option key={code} value={code}>
                      {locals.getCountryName(code)}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="column  hide-field-signup" data-col="1/1">
              <div className="label">
                Time Zone <span className="required-input">*</span>
              </div>
              <select
                className="select-input"
                name="timeZone"
                defaultValue="0b"
                value="0b"
              >
                <option value="-12">
                  (GMT-12:00) International Date Line West
                </option>
                <option value="-11">(GMT-11:00) Midway Island, Samoa</option>
                <option value="-10">(GMT-10:00) Hawaii</option>
                <option value="-9">(GMT-09:00) Alaska</option>
                <option value="-8a">
                  (GMT-08:00) Pacific Time (US & Canada)
                </option>
                <option value="-8b">
                  (GMT-08:00) Tijuana, Baja California
                </option>
                <option value="-7a">(GMT-07:00) Arizona</option>
                <option value="-7b">
                  (GMT-07:00) Chihuahua, La Paz, Mazatlan
                </option>
                <option value="-7c">
                  (GMT-07:00) Mountain Time (US & Canada)
                </option>
                <option value="-6a">(GMT-06:00) Central America</option>
                <option value="-6b">
                  (GMT-06:00) Central Time (US & Canada)
                </option>
                <option value="-6c">
                  (GMT-06:00) Guadalajara, Mexico City, Monterrey
                </option>
                <option value="-6d">(GMT-06:00) Saskatchewan</option>
                <option value="-5a">
                  (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                </option>
                <option value="-5b">
                  (GMT-05:00) Eastern Time (US & Canada)
                </option>
                <option value="-5c">(GMT-05:00) Indiana (East)</option>
                <option value="-4a">(GMT-04:00) Atlantic Time (Canada)</option>
                <option value="-4b">(GMT-04:00) Caracas, La Paz</option>
                <option value="-4c">(GMT-04:00) Manaus</option>
                <option value="-4d">(GMT-04:00) Santiago</option>
                <option value="-3.5">(GMT-03:30) Newfoundland</option>
                <option value="-3a">(GMT-03:00) Brasilia</option>
                <option value="-3b">
                  (GMT-03:00) Buenos Aires, Georgetown
                </option>
                <option value="-3c">(GMT-03:00) Greenland</option>
                <option value="-3d">(GMT-03:00) Montevideo</option>
                <option value="-2a">(GMT-02:00) Mid-Atlantic</option>
                <option value="-1a">(GMT-01:00) Cape Verde Is.</option>
                <option value="-1b">(GMT-01:00) Azores</option>
                <option value="0a">
                  (GMT+00:00) Casablanca, Monrovia, Reykjavik
                </option>
                <option value="0b">
                  (GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon,
                  London
                </option>
                <option value="1a">
                  (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna
                </option>
                <option value="1b">
                  (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague
                </option>
                <option value="1c">
                  (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                </option>
                <option value="1d">
                  (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb
                </option>
                <option value="1e">(GMT+01:00) West Central Africa</option>
                <option value="2a">(GMT+02:00) Amman</option>
                <option value="2b">
                  (GMT+02:00) Athens, Bucharest, Istanbul
                </option>
                <option value="2c">(GMT+02:00) Beirut</option>
                <option value="2d">(GMT+02:00) Cairo</option>
                <option value="2e">(GMT+02:00) Harare, Pretoria</option>
                <option value="2f">
                  (GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius
                </option>
                <option value="2g">(GMT+02:00) Jerusalem</option>
                <option value="2h">(GMT+02:00) Minsk</option>
                <option value="2i">(GMT+02:00) Windhoek</option>
                <option value="3a">(GMT+03:00) Kuwait, Riyadh, Baghdad</option>
                <option value="3b">
                  (GMT+03:00) Moscow, St. Petersburg, Volgograd
                </option>
                <option value="3c">(GMT+03:00) Nairobi</option>
                <option value="3d">(GMT+03:00) Tbilisi</option>
                <option value="3.5">(GMT+03:30) Tehran</option>
                <option value="4a">(GMT+04:00) Abu Dhabi, Muscat</option>
                <option value="4b">(GMT+04:00) Baku</option>
                <option value="4c">(GMT+04:00) Yerevan</option>
                <option value="4.5">(GMT+04:30) Kabul</option>
                <option value="5a">(GMT+05:00) Yekaterinburg</option>
                <option value="5b">
                  (GMT+05:00) Islamabad, Karachi, Tashkent
                </option>
                <option value="5.5a">(GMT+05:30) Sri Jayawardenapura</option>
                <option value="5.5b">
                  (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                </option>
                <option value="5.75">(GMT+05:45) Kathmandu</option>
                <option value="6a">(GMT+06:00) Almaty, Novosibirsk</option>
                <option value="6b">(GMT+06:00) Astana, Dhaka</option>
                <option value="6.5">(GMT+06:30) Yangon (Rangoon)</option>
                <option value="7a">(GMT+07:00) Bangkok, Hanoi, Jakarta</option>
                <option value="7b">(GMT+07:00) Krasnoyarsk</option>
                <option value="8a">
                  (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                </option>
                <option value="8b">(GMT+08:00) Kuala Lumpur, Singapore</option>
                <option value="8c">(GMT+08:00) Irkutsk, Ulaan Bataar</option>
                <option value="8d">(GMT+08:00) Perth</option>
                <option value="8e">(GMT+08:00) Taipei</option>
                <option value="9a">(GMT+09:00) Osaka, Sapporo, Tokyo</option>
                <option value="9b">(GMT+09:00) Seoul</option>
                <option value="9c">(GMT+09:00) Yakutsk</option>
                <option value="9.5">(GMT+09:30) Adelaide</option>
                <option value="9.5">(GMT+09:30) Darwin</option>
                <option value="10a">(GMT+10:00) Brisbane</option>
                <option value="10b">
                  (GMT+10:00) Canberra, Melbourne, Sydney
                </option>
                <option value="10c">(GMT+10:00) Hobart</option>
                <option value="10d">(GMT+10:00) Guam, Port Moresby</option>
                <option value="10e">(GMT+10:00) Vladivostok</option>
                <option value="11a">
                  (GMT+11:00) Magadan, Solomon Is., New Caledonia
                </option>
                <option value="12a">(GMT+12:00) Auckland, Wellington</option>
                <option value="12b">
                  (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                </option>
                <option value="13a">(GMT+13:00) Nuku alofa</option>
              </select>
            </div>

            <div className="column" data-col="1/1">
              <label htmlFor="email" className="label">
                E-mail <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                type="email"
                name="email"
                placeholder="E-mail"
                required
              />
            </div>

            <div className="column" data-col="1/1">
              <label className="checkbox-input">
                <input type="checkbox" name="agreeTOS" />
                <span className="checkbox" />
                <span className="text">
                  I agree to the MyStrengthBook{" "}
                  <a
                    href="https://mystrengthbook.com/terms-of-use/"
                    target="_blank"
                    className="form-link"
                  >
                    Terms of Use
                  </a>
                </span>
              </label>
            </div>
          </div>

          <div className="foot">
            <button className="button-input full" type="submit">
              Next
            </button>
          </div>
        </div>

        <div className="login-signup">
          Already have an account? <a href="/login">Login</a>
        </div>
        <div className="login-signup">
          Not {referAsClients ? "a client" : "an athlete"}?{" "}
          <a href="/signup-coach">Signup as a Coach HERE</a>
        </div>
      </form>
    </div>
  );
}

const Signup = (app) => {
  app
    .get("/signup", ({ res, isLoggedIn, flash }) => {
      if (isLoggedIn()) {
        flash("error", "Please log out before trying to sign up");
        return res.redirect("/dashboard");
      }

      return (res.body = <View />);
    })
    .get(
      "/resend-verification/:email",
      async ({ req: { params }, res, api, flash, assert, login }) => {
        const { token, email, userId } = await (
          await api("register", {
            method: "POST",
            body: {
              email: params.email,
              resend: true,
            },
          })
        ).json();
        login({ _id: userId, token, email });
        flash("success", "Successfully resent email verification");
        res.redirect("/setup/step1");
      }
    )
    .post(
      "/signup",
      async ({ req: { body }, res, api, flash, assert, login }) => {
        assert(
          process.browser,
          400,
          "Unable to process payment in current browser"
        );
        assert(body.first_name, 400, "A first name is required");
        assert(body.last_name, 400, "A last name is required");
        assert(body.country, 400, "A location is required");
        assert(body.timeZone, 400, "Please provide your time zone");
        assert(body.email, 400, "An email address is required");
        assert(
          body.agreeTOS,
          400,
          "You must agree to the Terms and Conditions to continue"
        );
        body.name = `${body.first_name} ${body.last_name}`;
        delete body.first_name;
        delete body.last_name;
        delete body.agreeTOS;

        const { token, email, userId } = await (
          await api("register", {
            method: "POST",
            body,
          })
        ).json();
        login({ _id: userId, token, email });
        const message = { type: "signUpSuccess", message: "close" };
        if (window.webkit) {
          window.webkit.messageHandlers.reactNative.postMessage(message);
        } else {
          window.postMessage(JSON.stringify(message), "*");
        }
        // skips email verification if coach
        res.redirect(
          `${body.coach ? "/setup/step2/" + token : "/setup/step1"}`
        );
      }
    );
};

export default Signup;
